import { useEffect, useState } from "react";
import { actionTypes as last } from "redux/charts-tables-data/select-last-protfolio-detail";
import { actionTypes as suprior } from "redux/charts-tables-data/select_Suprior_Industries";
import { actionTypes as portfolioIndusties } from "redux/charts-tables-data/select_last_portfolio_industries";
import { actionTypes as portfolio } from "redux/charts-tables-data/select_portfolio";
import { actionTypes as portfolioHistory } from "redux/charts-tables-data/select_portfolio_history";
import { actionTypes as key } from "redux/charts-tables-data/select_protfolio_key";
import { actionTypes as acinRiskSystematic } from "redux/charts-tables-data/systematic_unsystematic_risk";
import { BoxStyled } from "styledComponents/component";
import FilterBox from "./filterBox";
import Pie1Box from "./pie1";
import Pie2Box from "./pie2";
import RiskBox from "./risk";
import SummaryBoxReports from "./summaryBox";
import TreeMapBox from "./treeMapBox";
// import {actionTypes as actionAuthorityList} from "redux/option/number_of_options_of_portfolio_instruments";
import { convertDigitToEnglish } from "common/method/convertDigitToEnglish";
import {
  dateConverttShamsiToMiladi,
  getLastDateShamsi,
} from "common/method/date";
import { useDispatch, useSelector } from "react-redux";
import { actionTypes as option } from "redux/charts-tables-data/select-option-protfolio";
import ReturnBox from "./return";
import RiskSystematic from "./riskSystematic";
import ShowPortfolio from "./showPortfolio";
import LazySection from "common/lazySection";

const ReportsModule = () => {
  const dispatch = useDispatch();

  const [stateFilter, setstateFilter] = useState({
    from_date: undefined,
    to_date: undefined,
  });

  const [stateFilterDateType, setstateFilterDateType] = useState({
    from_date: "ten",
    flag: false,
  });

  const [authority, setAuthority] = useState({});

  const [interval, setinterval] = useState("1d");

  const apiCall = (type) => {
    let obj = {};
    Object.keys(stateFilter).forEach((itm) => {
      if (stateFilter[itm]) {
        obj[itm] = stateFilter[itm];
      }
    });

    let objDateType = {};
    Object.keys(stateFilterDateType).forEach((itm) => {
      if (stateFilterDateType[itm]) {
        objDateType[itm] = stateFilterDateType[itm];
      }
    });

    if (obj.from_date) {
      obj.from_date = `${dateConverttShamsiToMiladi(
        convertDigitToEnglish(obj.from_date),
      )} 00:00:00.000000`;
    }

    if (obj.to_date) {
      obj.to_date = `${dateConverttShamsiToMiladi(
        convertDigitToEnglish(obj.to_date),
      )} 00:00:00.000000`;
    }

    if (objDateType.from_date) {
      objDateType.from_date = `${dateConverttShamsiToMiladi(
        getLastDateShamsi(objDateType.from_date, true),
      )} 00:00:00.000000`;
    }
    if (objDateType.flag) {
      delete objDateType["flag"];
    }

    let data = {};

    if (type === "dateType") {
      data = { ...objDateType };
    } else if (type === "search") {
      data = { ...obj };
    } else {
      data = {};
    }

    const portfolioHistoryData = {
      ...data,
      aggs: {
        interval: {
          interval_len: interval,
          daily_volatility: "avg",
          daily_return: "sum",
        },
      },
    };

    dispatch({ type: portfolio.selectPortfolioAsync, payload: { data: data } });
    dispatch({
      type: portfolioHistory.selectPortfolioHistoryAsync,
      payload: { data: portfolioHistoryData },
    });
    dispatch({ type: key.selectPortfolioKeyAsync, payload: {} });
    dispatch({ type: last.selectPortfolidetailLastAsync, payload: {} });
    dispatch({
      type: portfolioIndusties.selectPortfolioIndustriesLastAsync,
      payload: {},
    });
    dispatch({
      type: suprior.selectSuperiorIndustriesAsync,
      payload: { data: data },
    });
    dispatch({ type: option.selectOptionPortfolioAsync, payload: {} });

    dispatch({
      type: acinRiskSystematic.portfolioRiskSystematicAsync,
      payload: {
        data: {
          to_date: `${dateConverttShamsiToMiladi(
            getLastDateShamsi("day", true),
          )} 00:00:00.000000`,
          from_date: `${dateConverttShamsiToMiladi(
            getLastDateShamsi("day", true),
          )} 00:00:00.000000`,
          ...data,
        },
      },
    });

    setstateFilterDateType((prev) => ({
      ...prev,
      flag: false,
    }));
  };

  useEffect(() => {
    apiCall("dateType");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interval]);

  useEffect(() => {
    if (stateFilterDateType.flag) {
      handleSubmitFilter("dateType");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateFilterDateType.flag]);

  const handleSubmitFilter = (type) => {
    if (type === "dateType") {
      setstateFilter({
        from_date: undefined,
        to_date: undefined,
      });
      apiCall(type);
    }
    if (type === "search") {
      setstateFilterDateType({
        from_date: undefined,
      });
      apiCall(type);
    }
  };

  const handleChangeFilter = (type, value) => {
    setstateFilter((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const handleChangeFilterdateType = (type, value) => {
    setstateFilterDateType((prev) => ({
      ...prev,
      [type]: value,
      flag: true,
    }));
  };

  const reducerselectKey = useSelector(
    (state) => state.select_portfolio_key_reducer,
  );
  const reducerportfolioDetailLast = useSelector(
    (state) => state.select_last_portfolio_detail_reducer,
  );
  const reducerportfolioIndustriesLast = useSelector(
    (state) => state.select_last_portfolio_industries_reducer,
  );
  const reducerportfolio = useSelector(
    (state) => state.select_portfolio_reducer,
  );
  const superiorReducer = useSelector(
    (state) => state.select_superior_industries_reducer,
  );
  const riskSystematicReducer = useSelector(
    (state) => state.reducer_portfolio_portfolioRisk_systematic,
  );

  let data = [
    {
      api: reducerportfolioDetailLast?.data,
      loading: reducerportfolioDetailLast?.loading,
      component: (
        <LazySection>
          <ShowPortfolio
            tip={
              "جدول ریز پرتفوی با توجه به اطلاعات روز گذشته شما محاسبه و نمایش داده می‌شود."
            }
            authority={authority}
          />
        </LazySection>
      ),
    },
    // {
    //   api: reducerselectKey?.data,
    //   loading: reducerselectKey?.loading,
    //   component: (
    //     <LazySection entry="blurReveal">
    //       <SummaryBoxReports
    //         tip={
    //           "مقایسه داده‌های کلی کاربر با میانگین کاربران کارگزاری پیشرو و وضعیت بازار"
    //         }
    //       />
    //     </LazySection>
    //   ),
    // },
    // {
    //   api: reducerportfolioDetailLast?.data,
    //   loading: reducerportfolioDetailLast?.loading,
    //   // component: <TreeMapBox tip={"مقایسه‌ی پر بازده‌ترین و کم‌ بازده‌ترین سهام ها‌ی کاربر"}/>,
    //   component: (
    //     <LazySection entry="slide-down">
    //       <TreeMapBox
    //         tip={
    //           "مقایسه‌ی پر بازده‌ترین و کم بازده‌ترین سهام های کاربر با مشخص کردن سود و ارزش دارایی"
    //         }
    //       />
    //     </LazySection>
    //   ),
    // },
    // {
    //   api: reducerportfolio?.data,
    //   loading: reducerportfolio?.loading,
    //   component: (
    //     <LazySection entry="zoom">
    //       <RiskBox
    //         tip={"نمایش دهنده مقدار ریسک کلی پرتفوی شما نسبت به شاخص فراریت"}
    //       />
    //     </LazySection>
    //   ),
    // },
    // // todo uncomment this part after data was ready
    // {
    //   api: reducerportfolioIndustriesLast?.data[0]?.body?.industries,
    //   loading: reducerportfolioIndustriesLast?.loading,
    //   component: (
    //     <LazySection entry="dropIn">
    //       <Pie1Box tip={"مشخص کردن درصد هر صنعت نسبت به پرتقوی کاربر"} />
    //     </LazySection>
    //   ),
    // },
    // {
    //   api: superiorReducer?.data,
    //   loading: superiorReducer?.loading,
    //   component: (
    //     <LazySection entry="fadeIn">
    //       <Pie2Box
    //         tip={"نشان دهنده‌ی مقدار گردش مالی شما بر روی صنایع مختلف"}
    //       />
    //     </LazySection>
    //   ),
    // },
    // {
    //   api: reducerportfolio?.data,
    //   loading: reducerportfolio?.loading,
    //   component: (
    //     <LazySection entry="slide-down">
    //       <ReturnBox tip={"مجموع بازدهی سهام معاملاتی کاربر"} />,
    //     </LazySection>
    //   ),
    // },
    // {
    //   api: riskSystematicReducer?.data,
    //   loading: riskSystematicReducer?.loading,
    //   component: (
    //     <LazySection entry="slide-up">
    //       <RiskSystematic
    //         tip={"نمایش دهنده مقدار ریسک سیستماتیک و غیر سیستماتیک"}
    //       />
    //     </LazySection>
    //   ),
    // },
  ];

  ////////////////////////////////////////////

  const ReducerAuthorityList = useSelector(
    (state) => state.number_of_options_of_portfolio_instruments_select_reducer,
  );

  // const apiSubmitAuthorityList = (isins) => {
  //
  //     let data = {
  //         data: {}
  //     }
  //     dispatch({
  //         type: actionAuthorityList?.selectnumber_of_options_of_portfolio_instrumentsAsync,
  //         payload: data
  //     })
  // }

  // useEffect(() => {
  //     apiSubmitAuthorityList()
  // }, []);

  useEffect(() => {
    if (Object?.keys(ReducerAuthorityList?.data)?.length) {
      setAuthority(ReducerAuthorityList?.data);
    }
  }, [ReducerAuthorityList]);

  return (
    <>
      {/* <LazySection entry="slide-up">
        <FilterBox
          handleChangeFilter={handleChangeFilter}
          stateFilter={stateFilter}
          handleChangeFilterdateType={handleChangeFilterdateType}
          stateFilterDateType={stateFilterDateType}
          handleSubmitFilter={handleSubmitFilter}
          interval={interval}
          setinterval={setinterval}
        />
      </LazySection> */}
      {/* <FilterBox2
        handleChangeFilter={handleChangeFilter}
        stateFilter={stateFilter}
        handleChangeFilterdateType={handleChangeFilterdateType}
        stateFilterDateType={stateFilterDateType}
        handleSubmitFilter={handleSubmitFilter}
      /> */}

      {data?.map((itm, ind) => (
        <BoxStyled>
          {itm.loading === true && (
            <div className=" top-0 left-0 right-0 bottom-0 flex justify-center items-center text-gray-400">
              {/* <CircularProgress /> */}
            </div>
          )}
          {ind !== 4 && itm.api?.length === 0 && itm.loading === false ? (
            <div className=" top-0 left-0 right-0 bottom-0 flex justify-center items-center text-black bg-white opacity-60 z-10">
              در این بازه زمانی معامله‌ای انجام نشده است. لطفا بازه زمانی را
              تغییر دهید.
            </div>
          ) : ind === 4 && itm.api?.length < 1 && itm.loading === false ? (
            <div className=" top-0 left-0 right-0 bottom-0 flex justify-center items-center text-black bg-white opacity-60 z-10">
              در این بازه زمانی معامله‌ای انجام نشده است. لطفا بازه زمانی را
              تغییر دهید.
            </div>
          ) : null}
          {itm.loading === false ? itm["component"] : null}
        </BoxStyled>
      ))}
    </>
  );
};

export default ReportsModule;
